import React from 'react'
import toast from 'react-hot-toast'
import { analyticsOverview } from '../../api/users.api'

// Satu fetch dipakai bersama oleh Card B/C/D (byLevel, timeline, dropOff)
// supaya kontrol range di atas grid cuma memicu satu request, bukan tiga —
// pola sama seperti ProgressAnalyticsScreen (CertAnalyticsScreens.jsx).
export function useDashboardOverview(lang) {
  const [range, setRange] = React.useState('30d')
  const [reloadTick, setReloadTick] = React.useState(0)
  const [data, setData] = React.useState(null)
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(false)

  React.useEffect(() => {
    let cancelled = false
    setLoading(true)
    setError(false)
    analyticsOverview(range)
      .then((d) => { if (!cancelled) setData(d) })
      .catch(() => {
        if (cancelled) return
        setError(true)
        toast.error(lang === 'id' ? 'Gagal memuat analitik' : 'Failed to load analytics')
      })
      .finally(() => { if (!cancelled) setLoading(false) })
    return () => { cancelled = true }
  }, [range, reloadTick, lang])

  const reload = React.useCallback(() => setReloadTick((n) => n + 1), [])

  return { range, setRange, data, loading, error, reload }
}
